import { render, staticRenderFns } from "./HiaVueTable2.vue?vue&type=template&id=299ecdb6&scoped=true&"
import script from "./HiaVueTable2.vue?vue&type=script&lang=js&"
export * from "./HiaVueTable2.vue?vue&type=script&lang=js&"
import style0 from "./HiaVueTable2.vue?vue&type=style&index=0&id=299ecdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ecdb6",
  null
  
)

export default component.exports